<template>
  <button class="back-button pointer pv3" id="go_back" @click="$router.go(-1)">
    <span class="f5 dim flex items-center ph2 ttl">
      <font-awesome-icon icon="chevron-left" />
      <span class="db pl2">назад</span>
    </span>
  </button>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.back-button {
  background-color: white;
  border: none;
}
</style>
